import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    IGuestIncidentDetailsAction,
    IGuestIncidentDetailsSuccessAction,
    IGuestIncidentDetailsErrorAction
} from '../../actions/guest/incident-details';
import { ITicketsState } from '@telstra-connect/tickets/state';
import { initialState } from '@telstra-connect/tickets/reducers/initial-state';

export type GuestIncidentDetailsAction
    = IGuestIncidentDetailsAction
    | IGuestIncidentDetailsSuccessAction
    | IGuestIncidentDetailsErrorAction;


const init = (state: ITicketsState, action: GuestIncidentDetailsAction) => ({
    ...state,
    guestIncidentDetailsRequest: {
        data: {
            incidentId: '',
            status: '',
            customerReference: '',
            description: '',
            createdOn: '',
            estimatedResolutionDate: '',
            actualResolutionDate: '',
            issueDetails: {},
        },
        status: action.status,
    }
});

const success = (state: ITicketsState, action: GuestIncidentDetailsAction) => ({
    ...state,
    guestIncidentDetailsRequest: {
        data: (action as IGuestIncidentDetailsSuccessAction).data,
        status: action.status
    }
});

const failure = (state: ITicketsState, action: GuestIncidentDetailsAction) => ({
    ...state,
    guestIncidentDetailsRequest: {
        data: {
            incidentId: '',
            status: '',
            customerReference: '',
            description: '',
            createdOn: '',
            estimatedResolutionDate: '',
            actualResolutionDate: '',
            issueDetails: {},
        },
        status: action.status,
        error: (action as IGuestIncidentDetailsErrorAction).error
    }
});

export const guestIncidentDetailsReducer = createAsyncReducer(initialState, init, success, failure);
